<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('inventory.operation.stock_count_entry.actual_count_entry') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t(
              'inventory.operation.stock_count_entry.actual_count_entry'
            ),
            href: '/stock-count_entrys'
          },
          {
            text: $t('create'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <form class="form-horizontal">
          <div class="row mb-3">
            <div class="col-sm-12 col-lg-6 col-md-12">
              <div class="form-group row">
                <label class="col-md-4 form-col-label control-label required">{{
                  $t('inventory.operation.stock_count_entry.date')
                }}</label>
                <div class="col-md-7">
                  <ts-date-picker-input
                    v-model="model.count_date"
                    disabled
                  ></ts-date-picker-input>
                  <div class="validate" v-if="errors.has('count_date')">
                    {{ errors.first('count_date') }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-4 form-col-label control-label required">{{
                  $t('inventory.operation.stock_count_entry.note')
                }}</label>
                <div class="col-md-7">
                  <textarea
                    v-model="model.note"
                    rows="3"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('note') }"
                  ></textarea>
                  <div class="invalid-feedback" v-if="errors.has('note')">
                    {{ errors.first('note') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <form>
          <div class="row">
            <div class="col-md-12">
              <div id="container-table">
                <div class="overflow-auto">
                  <ItemDetail v-model="model" :errors="errors" />
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-12 text-right">
              <ts-button
                class="btn-primary mr-2"
                @click.prevent="store"
                :waiting="saving"
                v-if="model.details.length"
                >{{ $t('save') }}</ts-button
              >
              <ts-button
                class="btn-primary mr-2"
                @click.prevent="saveNew"
                :waiting="saving_new"
                v-if="model.details.length"
                >{{ $t('save_add_new') }}</ts-button
              >
              <ts-button
                class="btn-default"
                @click="$router.push({ name: 'stock-count-entry' })"
                >{{ $t('cancel') }}</ts-button
              >
            </div>
          </div>
        </form>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import ItemDetail from './components/item-detail.vue';
export default {
  name: 'stock-count-entry-create',
  components: {
    ItemDetail
  },
  data() {
    return {
      model: {
        note: '',
        count_date: moment().format('DD-MM-YYYY'),
        details: []
      },
      errors: new Errors(),
      ready_fetch: false,
      saving: false,
      saving_new: false
    }
  },
  created() {
    this.fetchResourceBeforeCreate()
  },
  methods: {
    fetchResourceBeforeCreate() {
      this.ready_fetch = true
      this.$store
        .dispatch('stockCountEntry/dataBeforeCreate')
        .then(() => {
          this.ready_fetch = false
        })
        .catch(error => {
          this.ready_fetch = false
          this.$toasted.error(error.message)
        })
    },
    store() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('stockCountEntry/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'stock-count-entry' })
        })
        .catch(error => {
          this.saving = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    saveNew() {
      this.errors = new Errors()
      this.saving_new = true
      this.$store
        .dispatch('stockCountEntry/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
          this.saving_new = false
        })
        .catch(error => {
          this.saving_new = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    clearInput() {
      this.model = {
        note: '',
        count_date: moment().format('DD-MM-YYYY'),
        details: []
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('stockCountEntry/RESET_STATE')
    next()
  }
}
</script>
<style lang="css" scoped>
#container-table {
  max-height: 50vh;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
::-webkit-scrollbar {
  width: 3px; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}
/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  background: rgb(194, 194, 194);
}
table td {
  vertical-align: middle;
}
.only-border-bottom {
  border-top: none;
  border-left: none;
  border-right: none;
  outline: none;
}
.table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 2;
}
.table > tbody > tr > td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border: none !important;
}
#amountValue tr > td {
  padding: 5px;
}
</style>
